var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapping"},[(_vm.deviceType==='pc')?_c('x-payment-result-pc',{attrs:{"msg":"Purchase Successfully","isSuccess":"true"}}):_vm._e(),_vm._v(" "),(_vm.deviceType==='mobile')?_c('x-payment-result-mobile',{attrs:{"msg":"Purchase Successfully","isSuccess":"true"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71066285","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/recharge/success.vue
// module id = null
// module chunks = 